import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import 'vuetify/styles';
import './sass/ress.scss';

//import VueClipboard from 'vue-clipboard2'
import { longClickDirective } from 'vue-long-click'

// アプリケーションインスタンスの作成
const app = createApp(App); // createApp関数を使用

// プラグインと設定の適用 (use メソッドを使用)
app.use(router);
app.use(store);
app.use(vuetify);

// ディレクティブの登録
const longClickInstance = longClickDirective({ delay: 400, interval: 50 });
app.directive('longclick', longClickInstance);

// マウント
app.mount('#app');
